import React from 'react';
import { Flex, Link, LinkProps } from 'rebass';
import { useTheme } from 'emotion-theming';
import { Theme } from '../../theme';
import Icon, { IconType } from './Icon';

export type IconLinkProps = LinkProps & {
  /**
   * Icon to be included
   */
  icon?: IconType;

  iconSize?: number;

  /**
   * Should we move the icon to the end
   */
  iconAtEnd?: boolean;
  /**
   * Optional click handler
   */
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  /**
   * Link appears on dark background
   */
  isDark?: boolean;
  /**
   * Uses blue version; should be re-factored
   */
  isPrimary?: boolean;
};

const IconLink: React.FC<IconLinkProps> = ({
  icon = 'link',
  iconAtEnd,
  children,
  isDark,
  isPrimary,
  ...props
}) => {
  const theme: Theme = useTheme();
  const iconElement = icon && (
    <Icon icon={icon} size={theme.sizes.scale[props.iconSize ?? 4]} />
  );

  return (
    <Link
      variant={
        isDark ? 'iconLink' : isPrimary ? 'iconLinkPrimary' : 'iconLinkLight'
      }
      display="flex"
      {...(props as any)}
      sx={{
        gap: 1,
        ...props.sx,
      }}
    >
      {!iconAtEnd && iconElement}
      <Flex flexDirection="column">{children}</Flex>
      {iconAtEnd && iconElement}
    </Link>
  );
};

export default IconLink;
